"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestEntity;
exports.getPayloadData = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var getPayloadData = function getPayloadData(action) {
  if (action.payload && action.payload.data) {
    return action.payload.data;
  }

  return action.payload;
};

exports.getPayloadData = getPayloadData;

function requestEntity(requestEpicDescriptor) {
  return function ($action, _ref) {
    var getState = _ref.getState;
    return $action.ofType(requestEpicDescriptor.getInitiatingActionType()).pipe((0, _filter.filter)(function () {
      return requestEpicDescriptor.getRequestStatusTypeFilters().indexOf(requestEpicDescriptor.getRequestStatus(getState())) !== -1;
    }), (0, _mergeMap.mergeMap)(function (action) {
      return (0, _fromPromise.fromPromise)(requestEpicDescriptor.makeAPICall(getPayloadData(action), requestEpicDescriptor.getAdditionalParamsFromState(getState()))).pipe((0, _map.map)(function (response) {
        return requestEpicDescriptor.getSuccessAction()(response, getPayloadData(action));
      }), (0, _catchError.catchError)(function (error) {
        if (requestEpicDescriptor.sc404isSuccess && error.status === 404) {
          return (0, _of.of)(requestEpicDescriptor.getSuccessAction()(error, getPayloadData(action)));
        }

        return (0, _of.of)(requestEpicDescriptor.getFailureAction()(error, getPayloadData(action)));
      }), (0, _startWith.startWith)(requestEpicDescriptor.getRequestAction()(getPayloadData(action))));
    }));
  };
}